import { createSlice } from "@reduxjs/toolkit";

import { fetchBestFitSpread } from "./actions";

export const initialState = {
  data: null,
  isLoading: false,
  error: null,
};

const DEFAULT_ERROR = "Failed to load best fit spread";

const bestFitSpreadSlice = createSlice({
  name: "bestFitSpread",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBestFitSpread.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchBestFitSpread.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(fetchBestFitSpread.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error?.message ?? DEFAULT_ERROR;
      });
  },
});

export default bestFitSpreadSlice.reducer;
